export enum EBaseApiTags {
	CONFIG = 'CONFIG',
	NOTIFICATIONS_COUNT = 'NotificationsCount',
	NOTIFICATIONS_LIST = 'NotificationsList',
	PROFILE = 'Profile',
	TRANSACTION = 'Transaction',
	TRANSACTION_LIST = 'TransactionList',
	CHANNELS = 'CHANNELS',
	CHANNEL = 'CHANNEL',
	ACCOUNT_SETTINGS = 'AccountSettings',
	PLANNER_POSTS = 'PlannerPosts',
}
